import { render, staticRenderFns } from "./GpsSetting.vue?vue&type=template&id=67404471&scoped=true&"
import script from "./GpsSetting.vue?vue&type=script&lang=ts&"
export * from "./GpsSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GpsSetting.vue?vue&type=style&index=0&id=67404471&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67404471",
  null
  
)

export default component.exports